export default __webpack_public_path__ + "static/logo-ed347162dc6129b3b501cccdd30f1a6f.png";